import store from "../store";
import { get } from "lodash";

export default {
  install(Vue) {
    Vue.prototype.$permissions = new Vue({
      store,
      computed: {
        currentCompany() {
          const currentId = get(this.$user, "user.current_company_id");
          if (currentId === get(this.$user, "user.company_base")) return null;
          return get(this.$user, "user.companies", []).find(
            c => c.company.id === currentId
          );
        },
        isAdmin() {
          return this.currentCompany ? this.currentCompany.is_admin : true;
        }
      },
      methods: {
        hasPermission(key) {
          return this.isAdmin ? true : !!get(this.currentCompany.scope, key);
        }
      }
    });
  }
};
